var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-dialog',{attrs:{"dialog":_vm.dialog,"max-width":"1000px","width":"80%"},on:{"submit":_vm.submitForm}},[_c('base-course-form',{attrs:{"course":_vm.course},on:{"change":_vm.saveChanges}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }